import service from '@/plugins/service'

const deviceBaseUrl = '/station/device'
const deviceApi = {}

const protocolBaseUrl = '/station/protocol'
const protocolApi = {}

const resourceBaseUrl = '/station/resource'
const resourceApi = {}

deviceApi.list = (page, size) => {
  return service({
    url: `${deviceBaseUrl}/list/${page}/${size}`,
    method: 'get'
  })
}

deviceApi.listByCustomerId = (page, size, customerId) => {
  return service({
    url: `${deviceBaseUrl}/list/${page}/${size}/${customerId}`,
    method: 'get'
  })
}

deviceApi.searchCustomer = (content) => {
  return service({
    url: `${deviceBaseUrl}/search/customer`,
    method: 'get',
    params: {
      content: content
    }
  })
}

deviceApi.save = (form) => {
  return service({
    url: `${deviceBaseUrl}/save`,
    method: 'post',
    data: form
  })
}

deviceApi.get = (id) => {
  return service({
    url: `${deviceBaseUrl}/get/${id}`,
    method: 'get'
  })
}

deviceApi.delete = (ids) => {
  const formData = new FormData()
  ids.forEach(id => formData.append('id', id))
  return service({
    url: `${deviceBaseUrl}/delete`,
    method: 'post',
    data: formData
  })
}

deviceApi.latestHistoryRecord = (id) => {
  return service({
    url: `${deviceBaseUrl}/history/latest/${id}`,
    method: 'get'
  })
}

deviceApi.getDeviceType = () => {
  return service({
    url: `${deviceBaseUrl}/type/list`,
    method: 'get'
  })
}

deviceApi.getDeviceList = code => {
  return service({
    url: `${deviceBaseUrl}/group/get/code/${code}`,
    method: 'get'
  })
}

deviceApi.getDataPoints = deviceCode => {
  return service({
    url: `${deviceBaseUrl}/dataPoints/${deviceCode}`,
    method: 'get'
  })
}

deviceApi.getHistory = params => {
  return service({
    url: `${deviceBaseUrl}/history`,
    method: 'get',
    params
  })
}

deviceApi.searchDevice = (data, page = 1, size = 10) => {
  return service({
    url: `${deviceBaseUrl}/search/${page}/${size}`,
    method: 'post',
    data
  })
}

deviceApi.searchDeviceGroup = (data, page = 1, size = 10) => {
  return service({
    url: `${deviceBaseUrl}/group/search/${page}/${size}`,
    method: 'post',
    data
  })
}

deviceApi.getDayList = params => {
  return service({
    url: `${deviceBaseUrl}/history/report/day`,
    method: 'get',
    params
  })
}

deviceApi.getMonthList = params => {
  return service({
    url: `${deviceBaseUrl}/history/report/month`,
    method: 'get',
    params
  })
}
deviceApi.getExpression = data => {
  return service({
    url: `${deviceBaseUrl}/history/expression`,
    method: 'post',
    data
  })
}

deviceApi.queryAndSortDevice = (page, size, data) => {
  return service({
    url: `${deviceBaseUrl}/query/${page}/${size}`,
    method: 'post',
    data
  })
}
deviceApi.queryAndSortDeviceGroup = (page, size, data) => {
  return service({
    url: `${deviceBaseUrl}/group/query/${page}/${size}`,
    method: 'post',
    data
  })
}

deviceApi.exportExcel = params => {
  return service({
    url: `${deviceBaseUrl}/history/report/export`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

deviceApi.deleteHistoryData = data => {
  const formData = new FormData()

  for(let key in data) {
    formData.append(key, data[key])
  }

  return service({
    url: `${deviceBaseUrl}/delete/history`,
    method: 'post',
    data: formData
  })
}

deviceApi.write = (dtuCode, command, type) => {
  const formData = new FormData()
  formData.append('dtuCode', dtuCode)
  formData.append('command', command)
  formData.append('type', type)
  return service({
    url: '/connect/write',
    method: 'post',
    data: formData
  })
}

protocolApi.listAll = () => {
  return service({
    url: `${protocolBaseUrl}/listAll`,
    method: 'get'
  })
}

protocolApi.list = (page, size) => {
  return service({
    url: `${protocolBaseUrl}/list/${page}/${size}`,
    method: 'get'
  })
}

protocolApi.exist = (protocolCode) => {
  const formData = new FormData()
  formData.append('code', protocolCode)
  return service({
    url: `${protocolBaseUrl}/exist/protocol_code`,
    method: 'post',
    data: formData
  })
}

protocolApi.save = (form) => {
  switch (form.driverType) {
    case 'ModbusRTU':
      return service({
        url: '/driver/protocol/modbus_rtu/save',
        method: 'post',
        data: form
      })
    case 'DLT645_2007':
      return service({
        url: '/driver/protocol/dlt645_2007/save',
        method: 'post',
        data: form
      })
  }
}

protocolApi.get = (driverType, protocolCode) => {
  switch (driverType) {
    case 'ModbusRTU':
      return service({
        url: `/driver/protocol/modbus_rtu/get/code/${protocolCode}`,
        method: 'get'
      })
    case 'DLT645_2007':
      return service({
        url: `/driver/protocol/dlt645_2007/get/code/${protocolCode}`,
        method: 'get'
      })
  }
}

protocolApi.delete = async (list) => {
  const modbusRTUData = new FormData()
  const dlt6452007Data = new FormData()
  list.forEach(item => {
    switch (item.driverType) {
      case 'ModbusRTU':
        modbusRTUData.append('codes', item.protocolCode)
        break
      case 'DLT645_2007':
        dlt6452007Data.append('codes', item.protocolCode)
        break
    }
  })
  const a = await service({
    url: '/driver/protocol/modbus_rtu/delete',
    method: 'post',
    data: modbusRTUData
  })
  const b = await service({
    url: '/driver/protocol/dlt645_2007/delete',
    method: 'post',
    data: dlt6452007Data
  })
  return Promise.all([a, b])
}

protocolApi.searchProtocol = (data, page = 1, size = 10) => {
  return service({
    url: `${protocolBaseUrl}/search/${page}/${size}`,
    method: 'post',
    data
  })
}

protocolApi.queryAndSort = (page, size, data) => {
  return service({
    url: `${protocolBaseUrl}/query/${page}/${size}`,
    method: 'post',
    data
  })
}

protocolApi.refresh = code => {
  return service({
    url: `${protocolBaseUrl}/refresh/${code}`,
    method: 'post'
  })
}

protocolApi.generateModbus = (protocolCode, address, value) => {
  return service({
    url: '/driver/protocol/modbus_rtu/generate',
    method: 'get',
    params: {
      protocolCode,
      address,
      value
    }
  })
}

resourceApi.listCategory = () => {
  return service({
    url: `${resourceBaseUrl}/category/list`,
    method: 'get'
  })
}

resourceApi.saveCategory = (id, name) => {
  const formData = new FormData()
  if (id > 0) {
    formData.append('id', id)
  }
  formData.append('name', name)
  return service({
    url: `${resourceBaseUrl}/category/save`,
    method: 'post',
    data: formData
  })
}

resourceApi.list = (categoryId = 0) => {
  return service({
    url: `${resourceBaseUrl}/list/${categoryId}`,
    method: 'get'
  })
}

resourceApi.save = (resource) => {
  return service({
    url: `${resourceBaseUrl}/save`,
    method: 'post',
    data: resource
  })
}

resourceApi.remove = (ids) => {
  const formData = new FormData()
  ids.forEach(item => {
    formData.append('id', item)
  })
  return service({
    url: `${resourceBaseUrl}/remove`,
    method: 'post',
    data: formData
  })
}

resourceApi.upload = (categoryId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('categoryId', categoryId)
  return service({
    url: `${resourceBaseUrl}/upload`,
    method: 'post',
    data: formData
  })
}

export {
  deviceApi,
  protocolApi,
  resourceApi
}
